module.exports = __webpack_public_path__ + "img/live.d9f0e265.png";